import {useAuth} from "~/composables/useAuth";

export function useRedirectLogin() {
  const {on} = useEventBus();
  const {openModal} = useModal();
  const signInModal = () => openModal('sign-modal')
  const {isAuthenticated} = useAuth()

  const signUpModal = () => openModal('signup-modal')

  const navigateToOrSignIn = (uri: string) => {
    if (isAuthenticated.value) {
      navigateTo(uri);
    } else {
      signInModal()
      on('login-success', () => navigateTo(uri));
    }
  }

  const callbackOrSignIn = (callback: Function) => {
    if (isAuthenticated.value) {
      callback();
    } else {
      signInModal()
      on('login-success', () => callback());
    }
  }

  return {signInModal, signUpModal, navigateToOrSignIn, callbackOrSignIn}
}
